import React from 'react';
import { MarkupInput } from '../position-rate-settings-form/rate-inputs/MarkupInput';

type MarkupsInputsProps = {
  source: string;
  inheritedSettings: Record<string, any>;
  parentSettings: Record<string, any>;
  taxClassification: string;
};

export const MarkupsInputs = ({
  source,
  inheritedSettings,
  parentSettings,
  taxClassification,
}: MarkupsInputsProps) => {
  const isW2 = source.includes('w2');

  return (
    <>
      <MarkupInput
        source={source}
        field="invoicing_markup"
        label="Invoicing Markup"
        inheritedSettings={inheritedSettings}
        parentSettings={parentSettings}
        taxClassification={taxClassification}
      />
      <MarkupInput
        source={source}
        field="misc_markup"
        label="Misc Markup"
        inheritedSettings={inheritedSettings}
        parentSettings={parentSettings}
        taxClassification={taxClassification}
      />
      {isW2 && (
        <MarkupInput
          source={source}
          field="operational_markup"
          label="Operational Markup"
          inheritedSettings={inheritedSettings}
          parentSettings={parentSettings}
          taxClassification={taxClassification}
        />
      )}
    </>
  );
};
